import React, { useEffect } from "react";

// Globally animates any SVG path with [data-draw-on-load]
// Optional attributes:
// - data-draw-len="12345"  // force path length
// - data-draw-duration="2.0" // seconds
// - data-draw-delay="0.2"    // seconds
const SvgPathDrawOnLoad = () => {
  useEffect(() => {
    const animateAll = () => {
      try {
        const nodes = document.querySelectorAll('[data-draw-on-load]');
        nodes.forEach((el) => {
          if (!(el instanceof SVGPathElement)) return;
          if (el.dataset.drawAnimated === '1') return;

          let len = 0;
          const forced = el.getAttribute('data-draw-len');
          if (forced && !Number.isNaN(Number(forced))) {
            len = Number(forced);
          } else {
            try { len = el.getTotalLength(); } catch { len = 0; }
          }
          if (!len || !Number.isFinite(len)) return;

          const duration = Math.max(0.1, Number(el.getAttribute('data-draw-duration')) || 2);
          const delay = Math.max(0, Number(el.getAttribute('data-draw-delay')) || 0);

          el.style.transition = 'none';
          el.style.strokeDasharray = `${len}`;
          el.style.strokeDashoffset = `${len}`;
          // Force reflow before starting transition
          void el.getBoundingClientRect();
          el.style.transition = `stroke-dashoffset ${duration}s ease-out ${delay}s`;
          // Next tick to ensure transition applies
          requestAnimationFrame(() => {
            el.style.strokeDashoffset = '0';
            el.dataset.drawAnimated = '1';
          });
        });
      } catch {}
    };

    // Animate on mount (no dependency on loader events)
    const t = setTimeout(animateAll, 0);
    return () => clearTimeout(t);
  }, []);

  return null;
};

export default SvgPathDrawOnLoad;




